import { render, staticRenderFns } from "./fccListarCandidatos.vue?vue&type=template&id=12befea0"
import script from "./fccListarCandidatos.vue?vue&type=script&lang=js"
export * from "./fccListarCandidatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports